module.exports = __webpack_public_path__ + "static/img/pinpai-13.9341f875.png";